import React from 'react';
import styled from 'styled-components';

const Card = styled.div`
  display: inline-flex;
  align-items: center;
  border: 1px solid skyblue;
  border-radius: 8px;
  padding: 4px 12px;
  background-color: white;
  margin-left: 10px;
  font-size: 16px;
`;

const Text = styled.span`
  color: skyblue;
  margin-right: 8px;
  font-size: 16px;
`;

const CloseButton = styled.button`
  background-color: transparent;
  border: none;
  color: skyblue;
  cursor: pointer;
  font-size: 16px;
`;

interface ITextCardProps {
  text: string;
  onClick: () => void;
}

const TextCard: React.FC<ITextCardProps> = ({ text, onClick }: ITextCardProps) => {
  return (
    <Card>
      <Text>{text}</Text>
      <CloseButton type="button" onClick={onClick}>
        ×
      </CloseButton>
    </Card>
  );
};

export default TextCard;
